import styled from '@emotion/styled'
import { css } from '@emotion/react'

const iconStyles = () => css`
  label: icon;

  display: block;
`

const SvgIcon = styled('svg')(iconStyles)

export default SvgIcon
